'use client';

import { Loader2 } from 'lucide-react';

interface QuizButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'primary' | 'secondary';
  className?: string;
  type?: 'button' | 'submit';
}

export function QuizButton({
  children,
  onClick,
  disabled = false,
  loading = false,
  variant = 'primary',
  className = '',
  type = 'button',
}: QuizButtonProps) {
  const baseStyles = 'w-full py-4 px-6 rounded-xl font-semibold transition-all duration-200 flex items-center justify-center gap-2';

  const variantStyles = {
    primary: disabled || loading
      ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
      : 'bg-blue-600 text-white hover:bg-blue-700 active:scale-98',
    secondary: disabled || loading
      ? 'bg-gray-800 text-gray-500 cursor-not-allowed'
      : 'bg-gray-800 text-white hover:bg-gray-700 active:scale-98',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {loading && <Loader2 className="animate-spin" size={20} />}
      {children}
    </button>
  );
}
